module.exports = __webpack_public_path__ + "img/logo1c.5fa4bfb9.png";